import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalDialog,
  ModalClose,
  Typography,
  Alert,
  FormControl,
  FormLabel,
  Input,
  Button
} from '@mui/joy';
import axiosInstance from '../util/axiosConfig';

const emptyVendor = () => ({
  name: '',
  mobile: '',
  email: '',
  address: ''
});

const inputSx = {
  '&:hover': { borderColor: 'primary.500' },
  '&:focus-within': { borderColor: 'primary.500' }
};

const AddVendorModal = ({ open, onClose, onCreated }) => {
  const [form, setForm] = useState(emptyVendor);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setForm(emptyVendor());
    setError('');
  }, [open]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim()) {
      setError('Vendor name is required');
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post('/vendors', {
        name: form.name.trim(),
        mobile: form.mobile.trim() || undefined,
        email: form.email.trim() || undefined,
        address: form.address.trim() || undefined
      });
      onCreated?.(response.data.vendor);
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add vendor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ maxWidth: 400 }}>
        <ModalClose />
        <Typography level="h4" sx={{ mb: 2, color: 'primary.500' }}>
          Add Vendor
        </Typography>
        {error && (
          <Alert color="danger" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Name</FormLabel>
            <Input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="Vendor name"
              sx={inputSx}
            />
          </FormControl>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Mobile</FormLabel>
            <Input
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              placeholder="Mobile number"
              sx={inputSx}
            />
          </FormControl>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Email</FormLabel>
            <Input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              sx={inputSx}
            />
          </FormControl>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Address</FormLabel>
            <Input
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Address"
              sx={inputSx}
            />
          </FormControl>
          <Button
            type="submit"
            loading={loading}
            fullWidth
            sx={{
              backgroundColor: 'primary.500',
              '&:hover': { backgroundColor: 'primary.600' }
            }}
          >
            Add Vendor
          </Button>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default AddVendorModal;
